import { useGetAccountPartnerships } from './getAccountPartnerships';
import { useGetAccountRolesInPartners } from './getAccountRoleInPartner';
import { IPartnershipWithRole } from '../types/partnership';

interface IGetAccountPartnershipsWithRolesParams {
  accountId: string;
  pageSize: number;
  offset: number;
}

const useAccountPartnershipsWithRoles = ({
  accountId,
  pageSize,
  offset,
}: IGetAccountPartnershipsWithRolesParams) => {
  const partnershipsQuery = useGetAccountPartnerships({
    accountId,
    pageSize,
    offset,
  });

  const partnershipItems = partnershipsQuery.data?.items ?? [];

  const roleQueries = useGetAccountRolesInPartners({
    accountId,
    partnerIds: partnershipItems.map((p) => p.id),
  });

  const data: IPartnershipWithRole[] = partnershipItems.map(
    (partner, index) => ({
      ...partner,
      roleName: roleQueries[index]?.data ?? undefined,
      roleLoading: roleQueries[index]?.isLoading ?? false,
    })
  );

  return {
    data,
    total: partnershipsQuery.data?.total ?? 0,
    isLoading: partnershipsQuery.isLoading,
    isPartiallyLoading: roleQueries.some((q) => q.isLoading),
  };
};

export const getAccountPartnershipsWithRoles = useAccountPartnershipsWithRoles;
